import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _regeneratorRuntime from "@babel/runtime/regenerator";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { useCallback, useEffect, useState } from 'react';
import { HttpError } from './utils';
export var useLazyService = function useLazyService() {
  for (var _len = arguments.length, _ref = new Array(_len), _key = 0; _key < _len; _key++) {
    _ref[_key] = arguments[_key];
  }
  var request = _ref[0],
    controller = _ref[1],
    options = _ref[2];
  var _useState = useState(_objectSpread({
      loading: false,
      error: undefined,
      data: undefined
    }, options === null || options === void 0 ? void 0 : options.initialState)),
    _useState2 = _slicedToArray(_useState, 2),
    state = _useState2[0],
    setState = _useState2[1];
  var getData = useCallback( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var _response$headers, response, traceId, jsonResponse, isResponseText, resText;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          setState(function (s) {
            return _objectSpread(_objectSpread({}, s), {}, {
              loading: true
            });
          });
          _context.prev = 1;
          _context.next = 4;
          return request();
        case 4:
          response = _context.sent;
          traceId = response === null || response === void 0 || (_response$headers = response.headers) === null || _response$headers === void 0 ? void 0 : _response$headers.get('atl-traceid');
          isResponseText = false;
          _context.next = 9;
          return response === null || response === void 0 ? void 0 : response.text();
        case 9:
          _context.t0 = _context.sent;
          if (_context.t0) {
            _context.next = 12;
            break;
          }
          _context.t0 = '{}';
        case 12:
          resText = _context.t0;
          try {
            jsonResponse = JSON.parse(resText);
          } catch (_unused) {
            isResponseText = true;
          }
          if (!(!(response !== null && response !== void 0 && response.ok) || isResponseText)) {
            _context.next = 20;
            break;
          }
          if (!(options !== null && options !== void 0 && options.ErrorHandler)) {
            _context.next = 19;
            break;
          }
          throw new options.ErrorHandler(_objectSpread(_objectSpread({}, jsonResponse), {}, {
            traceId: traceId,
            status: response === null || response === void 0 ? void 0 : response.status,
            statusText: (response === null || response === void 0 ? void 0 : response.statusText) || resText
          }));
        case 19:
          throw new HttpError(response === null || response === void 0 ? void 0 : response.status, (response === null || response === void 0 ? void 0 : response.statusText) || resText, traceId);
        case 20:
          setState(function (s) {
            return _objectSpread(_objectSpread({}, s), {}, {
              loading: false,
              data: jsonResponse
            });
          });
          return _context.abrupt("return", response);
        case 24:
          _context.prev = 24;
          _context.t1 = _context["catch"](1);
          setState(function (s) {
            return _objectSpread(_objectSpread({}, s), {}, {
              loading: false,
              error: _context.t1
            });
          });
        case 27:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[1, 24]]);
  })), [request, options === null || options === void 0 ? void 0 : options.ErrorHandler]);
  useEffect(function () {
    return function () {
      controller.abort();
    };
  }, [controller]);
  return [getData, state];
};
export var useService = function useService() {
  for (var _len2 = arguments.length, _ref3 = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    _ref3[_key2] = arguments[_key2];
  }
  var request = _ref3[0],
    controller = _ref3[1],
    options = _ref3[2];
  var _useLazyService = useLazyService(request, controller, _objectSpread(_objectSpread({}, options), {}, {
      initialState: _objectSpread(_objectSpread({}, options === null || options === void 0 ? void 0 : options.initialState), {}, {
        loading: true
      })
    })),
    _useLazyService2 = _slicedToArray(_useLazyService, 2),
    getData = _useLazyService2[0],
    state = _useLazyService2[1];
  useEffect(function () {
    getData();
  }, [getData]);
  return state;
};